function tooMuchRequestHandler(error) {
  console.log('[tooMuchRequestHandler] Checking error:', {
    status: error?.response?.status,
    message: error?.message,
    code: error?.code,
  })

  if (error?.response?.status === 429) {
    console.error('[tooMuchRequestInterceptor] Too many requests, please try again later')
    return true
  }

  console.log('[tooMuchRequestHandler] Not 429, re-throwing error')
  throw error
}

export function tooMuchRequestInterceptor(client) {
  client.interceptors.response.use(request => request, tooMuchRequestHandler)
}
